/**
 * Created by Claude on 22.03.2026
 */

const HungryGamesOrder = function (customer) {
    this.customer = customer;
    this.customers = customer.customers;

    this.bg = {
        vertical: bundles.questsgroupicon.jsons.hungry_games_bg_ver_json
    };
    this.timer = {
        bg: bundles.questsgroupicon.frames.hungry_games_timer_bg_png,
        leftIcon: bundles.questsgroupicon.frames.hungry_games_timer_icon_png,
        rightIcon: bundles.hungry_games_orders.frames.wing_reward_icon_png
    };
    this.duration = HungryGamesOrder.LEVEL_DURATION;
    this.ordersConfig = bundles.hungry_games_orders.jsons.orders_config_json;

    this.levelStartTime = cleverapps.dataLoader.load(DataLoader.TYPES.HUNGRY_GAMES_MERGE2) || Date.now();
    cleverapps.dataLoader.save(DataLoader.TYPES.HUNGRY_GAMES_MERGE2, this.levelStartTime);

    customer.eventOrder = this;
    if (customer.recipe) {
        customer.recipe.eventOrder = this;
        this.customers.forceRewardsUpdate();
    }
};

HungryGamesOrder.prototype.getTimeLeft = function () {
    if (this.levelStartTime) {
        return Math.max(0, this.levelStartTime + this.duration - Date.now());
    }
    return 0;
};

HungryGamesOrder.prototype.startLevel = function () {
    this.levelStartTime = Date.now();
    cleverapps.dataLoader.save(DataLoader.TYPES.HUNGRY_GAMES_MERGE2, this.levelStartTime);

    this.startLevelTimeout();
};

HungryGamesOrder.prototype.assignOrder = function (level) {
    if (this.customer.recipe) {
        return;
    }

    this.customer.order(this.generateOrder(level));
    this.customers.save();

    this.customers.updateMarks();
    cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
};

HungryGamesOrder.prototype.generateOrder = function (level) {
    const allCases = this.ordersConfig.resolve().getJson();
    let cases = allCases[level];
    if (!cases) {
        cases = allCases[0];
    }

    const shuffled = cases.slice();
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = temp;
    }

    for (let k = 0; k < shuffled.length; k++) {
        const items = shuffled[k];
        let allValid = true;
        for (let m = 0; m < items.length; m++) {
            const generator = OrdersAlgoHelper.GeneratorForItem(items[m].code, OrdersAlgoHelper.DefaultGenerators());
            if (!generator) {
                allValid = false;
                break;
            }
            const { maxStage } = OrdersAlgoHelper.StageRange(items[m].code);
            if (items[m].stage > maxStage) {
                allValid = false;
                break;
            }
        }
        if (allValid) {
            return {
                eventOrder: this,
                ingredients: items.map((item) => ({ unit: item, amount: 1 }))
            };
        }
    }

    return {
        eventOrder: this,
        ingredients: [{ unit: { code: "a", stage: 6 }, amount: 1 }]
    };
};

HungryGamesOrder.prototype.removeOrder = function () {
    this.clearLevelTimeout();

    if (this.customer.recipe) {
        this.customer.recipe = undefined;
        this.customer.reward = undefined;
        this.customer.expReward = undefined;
        this.customer.raveReviewReward = undefined;

        this.customers.save();
        this.customers.updateMarks();
        cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
    }

    this.customer.eventOrder = undefined;
    cleverapps.dataLoader.remove(DataLoader.TYPES.HUNGRY_GAMES_MERGE2);
};

HungryGamesOrder.prototype.startLevelTimeout = function () {
    this.clearLevelTimeout();

    const timeLeft = this.getTimeLeft();
    if (timeLeft <= 0) {
        return;
    }

    this._levelTimeout = cleverapps.timeouts.setTimeout(() => {
        this._levelTimeout = undefined;
        this.onTimeExpired();
    }, timeLeft);
};

HungryGamesOrder.prototype.clearLevelTimeout = function () {
    if (this._levelTimeout) {
        cleverapps.timeouts.clearTimeout(this._levelTimeout);
        this._levelTimeout = undefined;
    }
};

HungryGamesOrder.prototype.onTimeExpired = function () {
    this.removeOrder();
    this.onTimeExpiredCallback && this.onTimeExpiredCallback();
};

HungryGamesOrder.LEVEL_DURATION = cleverapps.parseInterval("10 minutes");
